export interface ILeadSubmitModel {
    id?: string;
    lead: string;
    request_number?: string;
    requirements?: any;
    transaction_type?: string;
    csc_revalidation_required?: boolean;
}

export interface ILeadSubmitError {
    lead: string[]
}

export class LeadSubmitModel {
    id?: string;
    lead: string;
    request_number: string;
    requirements?: any;
    transaction_type?: string;
    csc_revalidation_required?: boolean;

    error: ILeadSubmitError;

    validations = {}

    constructor(lead: string) {
        this.id = null;
        this.lead = lead;
        this.request_number = null;
        this.requirements = [];
        this.transaction_type = null;
        this.csc_revalidation_required = true;

        this.resetErrors();
    }

    resetErrors() {
        this.error = {
            lead: [],
        }
    }

    is_valid() {
        return this.lead != null;
    }

    getSavePayload(): ILeadSubmitModel {
        return {
            lead: this.lead
        }
    }

    savePayloadToModel(payload: ILeadSubmitModel) {
        this.id = payload.id;
        this.lead = payload.lead;
        this.request_number = payload.request_number;
        this.requirements = payload.requirements;
        this.transaction_type = payload.transaction_type;
        this.csc_revalidation_required = payload.csc_revalidation_required;
    }


}
